import Nullstack from 'nullstack';
export default function IconAddressBook({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-address-book",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M20 6v12a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2z"
  }), "   ", Nullstack.element("path", {
    d: "M10 16h6"
  }), "   ", Nullstack.element("circle", {
    cx: "13",
    cy: "11",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M4 8h3"
  }), "   ", Nullstack.element("path", {
    d: "M4 12h3"
  }), "   ", Nullstack.element("path", {
    d: "M4 16h3"
  }), " ");
}